import React, { memo, useState } from 'react';
import { EditRegular, ArrowSwapRegular, ImageMultipleRegular } from '@fluentui/react-icons';
import { Image as FluentImage } from '@bingads-webui-react/fabric-control';
import { Button, tokens } from '@fluentui/react-components';
import { useStyles } from './style';
import { ImagePreviewProps } from './type';

export const ImagePreview = memo(({
  onEdit,
  i18n,
  onReplace,
  hideEditBtn,
  hideReplaceBtn,
  previewImage,
  isMultiplePreview,
  type,
}: ImagePreviewProps) => {
  const classes = useStyles();
  const [showActionBtn, setShowActionBtn] = useState(false);
  const onMouseEnter = () => {
    setShowActionBtn(true);
  };
  const onMouseLeave = () => {
    setShowActionBtn(false);
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onMouseEnter();
    }
  };
  return (
    <div className={classes.imagePreviewContainer}>
      <div
        className="image-preview"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        tabIndex={0}
        onKeyDown={onKeyDown}
        role="button"
      >
        {
          isMultiplePreview ?
            <Button
              icon={<ImageMultipleRegular color={tokens.colorNeutralForeground4} />}
              size="medium"
              data-type={type}
              className={classes.multipleBtn}
              onClick={onReplace}
            >
              {i18n.getString(_TL_('Adding a new image will replace all images in every banner size. '))}
            </Button>
            : <FluentImage className={classes.previewImage} src={previewImage} alt="brand-kit" />
        }
        {!isMultiplePreview && showActionBtn && <span className={classes.overlay} />}
        {!isMultiplePreview && showActionBtn && (
          <div className={classes.actionBtns}>
            {!hideEditBtn && (
              <Button
                icon={<EditRegular color={tokens.colorNeutralForeground1} />}
                size="medium"
                data-type={type}
                className="edit_btn"
                onClick={onEdit}
              />
            )}
            {!hideReplaceBtn && (
            <Button
              icon={<ArrowSwapRegular color={tokens.colorNeutralForeground1} />}
              size="medium"
              data-type={type}
              className="rep_btn"
              onClick={onReplace}
              aria-label={i18n.getString(_TL_('Replace image.'))}
            />
            )}
          </div>
        )}
      </div>
    </div>
  );
});
